"use client"

import { A } from "src/components/generic/A"
import { Icon } from "src/components/generic/Icon"
import { Tooltip } from "src/components/generic/Tooltip"
import { SocialLinkData } from "src/components/home/HomePageSocialSection"
import { useEventCallback } from "src/components/hooks/useEventCallback"
import { socialLinks } from "src/components/sections/footer/socialLinks"
import { posthogCapture } from "src/integrations/posthog/events"

type SocialLinkProps = {
  link: SocialLinkData
}

const SocialLink = ({ link }: SocialLinkProps) => {
  const onClick = useEventCallback(() => {
    posthogCapture("social_link_clicked", { ...link, location: "footer" })
  })

  return (
    <Tooltip text={link.name} variant="light">
      <A
        href={link.href}
        aria-label={link.name}
        className="flex rounded-full p-2 hover:bg-white/75 active:bg-white"
        onClick={onClick}
      >
        <Icon name={link.icon} className="size-8" />
      </A>
    </Tooltip>
  )
}

export const FooterSocialSection = () => {
  return (
    <nav className="flex flex-col items-center">
      <ul className="flex items-center gap-2">
        {socialLinks.map((link, index) => {
          return (
            <li key={index}>
              <SocialLink link={link} />
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
